import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

type Props = {
  maxHeight?: string;
};

// eslint-disable-next-line no-restricted-syntax
export const DatagridStickyContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'maxHeight',
})<Props>(({ theme, maxHeight = 'calc(100vh - 250px)' }) => ({
  overflowX: 'visible',
  overflowY: 'visible',

  '& > div:has(> .MuiToolbar-root)': {
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 10,
    width: 'fit-content',
    backgroundColor: theme.palette.background.paper,
  },

  '& .RaDatagrid-tableWrapper': {
    overflowX: 'auto',
    overflowY: 'auto',
    maxHeight,
  },
}));
